// extracted by mini-css-extract-plugin
module.exports = {"ad-wrapper":"taboola-m__ad-wrapper__1Pc27"};